// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sq-brand: #e63b11;
  --sq-brand-strong: #c9320c;
  --sq-brand-stronger: #a82a0a;
  --sq-brand-soft: #fdeee9;
  --sq-navy: #01426a;
  --sq-navy-deep: #012a45;
  --sq-navy-darker: #011f33;
  --sq-sky: #77c5d5;
  --sq-bg: #f3f5f8;
  --sq-surface: #ffffff;
  --sq-surface-2: #f8fafc;
  --sq-surface-3: #eef2f6;
  --sq-border: #e1e7ee;
  --sq-border-strong: #c8d1dc;
  --sq-text: #10212f;
  --sq-text-2: #43546a;
  --sq-text-3: #5a6b80;
  --sq-good: #067647;
  --sq-good-bg: #ecfdf3;
  --sq-good-line: #abefc6;
  --sq-warn: #a85606;
  --sq-warn-bg: #fff8eb;
  --sq-warn-line: #fbd98a;
  --sq-bad: #b42318;
  --sq-bad-bg: #fef3f2;
  --sq-bad-line: #fecdca;
  --sq-info: #01426a;
  --sq-info-bg: #eef7fc;
  --sq-info-line: #b6def0;
  --sq-neutral: #43546a;
  --sq-neutral-bg: #f1f4f8;
  --sq-neutral-line: #dde4ec;
  --sq-cat-available: #45b854;
  --sq-cat-ready: #f08a24;
  --sq-cat-complete: #3a9bb0;
  --sq-cat-in-use: #e9c400;
  --sq-cat-error: #b91c1c;
  --sq-cat-out-of-order: #6c757d;
  --sq-cat-unknown: #adb5bd;
  --sq-font: "Inter Variable", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, sans-serif;
  --sq-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace;
  --sq-radius-sm: 8px;
  --sq-radius: 12px;
  --sq-radius-lg: 16px;
  --sq-shadow-sm: 0 1px 2px rgba(16, 33, 47, 0.05);
  --sq-shadow: 0 1px 3px rgba(16, 33, 47, 0.06), 0 6px 16px -8px rgba(16, 33, 47, 0.1);
  --sq-shadow-lg: 0 12px 32px -8px rgba(16, 33, 47, 0.24);
  --sq-focus: 0 0 0 3px rgba(1, 66, 106, 0.28);
  --sq-sidebar-w: 256px;
  --sq-topbar-h: 56px;
  --sq-bottomnav-h: 60px;
  --sq-safe-bottom: env(safe-area-inset-bottom, 0px);
  --sq-page-x: clamp(0.875rem, 2.4vw, 1.75rem);
}

.sq-login {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);
  min-height: 100vh;
  min-height: 100dvh;
}
@media (max-width: 991px) {
  .sq-login {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto 1fr;
  }
}

.sq-login-brand {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.5rem;
  padding: clamp(2rem, 6vw, 5rem);
  background: var(--sq-navy-deep);
  color: #fff;
}
.sq-login-brand img {
  width: 132px;
  height: auto;
  border-radius: 16px;
}
.sq-login-brand p {
  max-width: 26rem;
  margin: 0;
  font-size: 1.0625rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.75);
}
@media (max-width: 991px) {
  .sq-login-brand {
    gap: 0;
    padding: 1.25rem 1.5rem;
    align-items: center;
  }
  .sq-login-brand img {
    width: 68px;
    border-radius: 10px;
  }
  .sq-login-brand p {
    display: none;
  }
}

.sq-login-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  background: var(--sq-surface);
}
@media (max-width: 991px) {
  .sq-login-panel {
    align-items: flex-start;
  }
}

.sq-login-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  max-width: 360px;
}
.sq-login-form h1 {
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin: 0;
}
.sq-login-form .sq-login-sub {
  margin: -0.75rem 0 0.25rem;
  font-size: 0.875rem;
  color: var(--sq-text-3);
}
.sq-login-form .alert {
  margin: 0;
}
.sq-login-form .sq-field {
  flex: none;
}
.sq-login-form .sq-field > span {
  font-size: 0.8125rem;
}
.sq-login-form .sq-input {
  min-height: 44px;
}
.sq-login-form .btn {
  min-height: 44px;
  margin-top: 0.25rem;
}

.sq-login-password {
  position: relative;
  display: block;
}
.sq-login-password .sq-input {
  padding-right: 2.75rem;
}
.sq-login-password button {
  position: absolute;
  inset: 0 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  padding: 0;
  color: var(--sq-text-3);
  background: transparent;
  border: 0;
  border-radius: var(--sq-radius-sm);
  cursor: pointer;
}
.sq-login-password button:hover {
  color: var(--sq-navy);
}`, "",{"version":3,"sources":["webpack://./src/styles/tokens.scss","webpack://./src/components/styles/login.scss"],"names":[],"mappings":"AAOA;EAGE,mBAAA;EACA,0BAAA;EACA,4BAAA;EACA,wBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,iBAAA;EAGA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,2BAAA;EAGA,kBAAA;EACA,oBAAA;EACA,oBAAA;EAIA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;EACA,0BAAA;EAGA,2BAAA;EACA,uBAAA;EACA,0BAAA;EACA,wBAAA;EACA,uBAAA;EACA,8BAAA;EACA,yBAAA;EAGA;uCAAA;EAEA,sFAAA;EAGA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gDAAA;EACA,oFAAA;EACA,uDAAA;EACA,4CAAA;EAIA,qBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kDAAA;EACA,4CAAA;ACxBF;;AArDA;EACE,aAAA;EACA,sDAAA;EACA,iBAAA;EACA,kBAAA;AAwDF;AAtDE;EANF;IAOI,qCAAA;IACA,4BAAA;EAyDF;AACF;;AAtDA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,+BAAA;EACA,+BAAA;EACA,WAAA;AAyDF;AAvDE;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AAyDJ;AAtDE;EACE,gBAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;EACA,gCAAA;AAwDJ;AArDE;EAvBF;IAwBI,MAAA;IACA,uBAAA;IACA,mBAAA;EAwDF;EAtDE;IACE,WAAA;IACA,mBAAA;EAwDJ;EArDE;IACE,aAAA;EAuDJ;AACF;;AAnDA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,6BAAA;AAsDF;AApDE;EAPF;IAQI,uBAAA;EAuDF;AACF;;AApDA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AAuDF;AArDE;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,SAAA;AAuDJ;AApDE;EACE,0BAAA;EACA,mBAAA;EACA,uBAAA;AAsDJ;AAnDE;EACE,SAAA;AAqDJ;AAlDE;EACE,UAAA;AAoDJ;AAjDE;EACE,oBAAA;AAmDJ;AAhDE;EACE,gBAAA;AAkDJ;AA/CE;EACE,gBAAA;EACA,mBAAA;AAiDJ;;AA7CA;EACE,kBAAA;EACA,cAAA;AAgDF;AA9CE;EACE,sBAAA;AAgDJ;AA7CE;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,kCAAA;EACA,eAAA;AA+CJ;AA7CI;EACE,qBAAA;AA+CN","sourcesContent":["// Design tokens — the single source of truth for colour, type, space and depth.\n// Every component reads these CSS variables; nothing else should hard-code a hex.\n\n// Breakpoints (Sass only — media queries can't read CSS variables).\n$bp-phone: 767px; // Up to here: single column, stacked tables, bottom sheets.\n$bp-shell: 991px; // Up to here: top bar + bottom nav instead of the sidebar.\n\n:root {\n  // Brand. `--sq-brand` is the logo orange, used for accents and large marks.\n  // `--sq-brand-strong` carries white text at AA contrast (the logo orange is 4.2:1).\n  --sq-brand: #e63b11;\n  --sq-brand-strong: #c9320c;\n  --sq-brand-stronger: #a82a0a;\n  --sq-brand-soft: #fdeee9;\n  --sq-navy: #01426a;\n  --sq-navy-deep: #012a45;\n  --sq-navy-darker: #011f33;\n  --sq-sky: #77c5d5;\n\n  // Surfaces and lines.\n  --sq-bg: #f3f5f8;\n  --sq-surface: #ffffff;\n  --sq-surface-2: #f8fafc;\n  --sq-surface-3: #eef2f6;\n  --sq-border: #e1e7ee;\n  --sq-border-strong: #c8d1dc;\n\n  // Text.\n  --sq-text: #10212f;\n  --sq-text-2: #43546a;\n  --sq-text-3: #5a6b80;\n\n  // Status tones. Reserved for state — never decoration — and always paired\n  // with a label or icon so meaning never rests on colour alone.\n  --sq-good: #067647;\n  --sq-good-bg: #ecfdf3;\n  --sq-good-line: #abefc6;\n  --sq-warn: #a85606;\n  --sq-warn-bg: #fff8eb;\n  --sq-warn-line: #fbd98a;\n  --sq-bad: #b42318;\n  --sq-bad-bg: #fef3f2;\n  --sq-bad-line: #fecdca;\n  --sq-info: #01426a;\n  --sq-info-bg: #eef7fc;\n  --sq-info-line: #b6def0;\n  --sq-neutral: #43546a;\n  --sq-neutral-bg: #f1f4f8;\n  --sq-neutral-line: #dde4ec;\n\n  // Machine states on the Status page.\n  --sq-cat-available: #45b854;\n  --sq-cat-ready: #f08a24;\n  --sq-cat-complete: #3a9bb0;\n  --sq-cat-in-use: #e9c400;\n  --sq-cat-error: #b91c1c;\n  --sq-cat-out-of-order: #6c757d;\n  --sq-cat-unknown: #adb5bd;\n\n  // Type.\n  --sq-font: \"Inter Variable\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto,\n    \"Helvetica Neue\", Arial, sans-serif;\n  --sq-mono: ui-monospace, SFMono-Regular, Menlo, Consolas, \"Liberation Mono\", monospace;\n\n  // Shape and depth.\n  --sq-radius-sm: 8px;\n  --sq-radius: 12px;\n  --sq-radius-lg: 16px;\n  --sq-shadow-sm: 0 1px 2px rgba(16, 33, 47, 0.05);\n  --sq-shadow: 0 1px 3px rgba(16, 33, 47, 0.06), 0 6px 16px -8px rgba(16, 33, 47, 0.1);\n  --sq-shadow-lg: 0 12px 32px -8px rgba(16, 33, 47, 0.24);\n  --sq-focus: 0 0 0 3px rgba(1, 66, 106, 0.28);\n\n  // Shell. The bottom offset keeps content clear of the fixed nav and the\n  // iPhone home indicator.\n  --sq-sidebar-w: 256px;\n  --sq-topbar-h: 56px;\n  --sq-bottomnav-h: 60px;\n  --sq-safe-bottom: env(safe-area-inset-bottom, 0px);\n  --sq-page-x: clamp(0.875rem, 2.4vw, 1.75rem);\n}\n","@import \"../../styles/tokens.scss\";\n\n.sq-login {\n  display: grid;\n  grid-template-columns: minmax(0, 1.1fr) minmax(0, 1fr);\n  min-height: 100vh;\n  min-height: 100dvh;\n\n  @media (max-width: $bp-shell) {\n    grid-template-columns: minmax(0, 1fr);\n    grid-template-rows: auto 1fr;\n  }\n}\n\n.sq-login-brand {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 1.5rem;\n  padding: clamp(2rem, 6vw, 5rem);\n  background: var(--sq-navy-deep);\n  color: #fff;\n\n  img {\n    width: 132px;\n    height: auto;\n    border-radius: 16px;\n  }\n\n  p {\n    max-width: 26rem;\n    margin: 0;\n    font-size: 1.0625rem;\n    line-height: 1.5;\n    color: rgba(255, 255, 255, 0.75);\n  }\n\n  @media (max-width: $bp-shell) {\n    gap: 0;\n    padding: 1.25rem 1.5rem;\n    align-items: center;\n\n    img {\n      width: 68px;\n      border-radius: 10px;\n    }\n\n    p {\n      display: none;\n    }\n  }\n}\n\n.sq-login-panel {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem 1.5rem;\n  background: var(--sq-surface);\n\n  @media (max-width: $bp-shell) {\n    align-items: flex-start;\n  }\n}\n\n.sq-login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100%;\n  max-width: 360px;\n\n  h1 {\n    font-size: 1.5rem;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n    margin: 0;\n  }\n\n  .sq-login-sub {\n    margin: -0.75rem 0 0.25rem;\n    font-size: 0.875rem;\n    color: var(--sq-text-3);\n  }\n\n  .alert {\n    margin: 0;\n  }\n\n  .sq-field {\n    flex: none;\n  }\n\n  .sq-field > span {\n    font-size: 0.8125rem;\n  }\n\n  .sq-input {\n    min-height: 44px;\n  }\n\n  .btn {\n    min-height: 44px;\n    margin-top: 0.25rem;\n  }\n}\n\n.sq-login-password {\n  position: relative;\n  display: block;\n\n  .sq-input {\n    padding-right: 2.75rem;\n  }\n\n  button {\n    position: absolute;\n    inset: 0 0 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    padding: 0;\n    color: var(--sq-text-3);\n    background: transparent;\n    border: 0;\n    border-radius: var(--sq-radius-sm);\n    cursor: pointer;\n\n    &:hover {\n      color: var(--sq-navy);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
